<template>
  <div v-if="show" class="course-share">
    <Button @click="shareCourse()" class="course-share-btn" icon="share-o" round type="danger"  />
  </div>
</template>

<script>
import { Button } from "vant"
import { checkShareLinkAuth,shareLink } from "@/api/courseShare.js"
import {getShareInfoConfig, shareNative} from "@/utils/JSBridge";
export default {
  props: {
    courseName:String,
    courseCover:String
  },
  data:function () {
    return {
      show:false
    }
  },
  created() {
    checkShareLinkAuth({}).then(r=>{
      if(r){
        this.show = true
      }
    })
  },
  methods: {
    shareCourse(){
      let isPor = "production" === process.env.NODE_ENV && undefined === process.env.VUE_APP_MODE
      let shareUrl = isPor ? `https://opacts.hulian120.com/activity-course-share`:`https://mw.hulian120.com/249`
      shareLink({}).then(shareId=>{
        // 领取【${this.courseName}】7天学习权限

        let shareConfig = getShareInfoConfig({
          shareTitle: `送你[${this.courseName}]课程7天免费学习权益，24小时限时领取`,
          shareContent:'【点击查看详情】',
          shareUrl: `${shareUrl}/index.html?shareId=${shareId}&id=${window.PAGE_PARAMS.courseId}`,
          shareImgUrl: this.courseCover,
          sharePlatform:['WEIXIN','WEIXIN_CIRCLE','QQ','SINA']
        });
        shareNative(shareConfig);
      })
    }
  },
  components:{Button}
}
</script>

<style lang="scss" scoped>
.course-share {
  position: fixed;
  bottom: 80px;
  right: 60px;
  z-index: 1000;
  .course-share-btn{
    width: 50px;
    height: 50px;
    font-size: 20px;
    box-shadow: 0 0 8px rgba(0,0,0,.3);
  }
}
</style>
